var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.02967 9.31463L15.9484 3.74421L10.378 17.6629L8.11939 12.0417L7.65544 12.2282L8.11939 12.0417C8.0336 11.8282 7.86437 11.659 7.65086 11.5732L7.46444 12.0372L7.65086 11.5732L2.02967 9.31463Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.84413 11.8486L12.2236 7.46914",
    stroke: "white",
    strokeWidth: 0.963441,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSender);
export default __webpack_public_path__ + "static/media/icon_sender.66a6a07e2fcb8ec434e6323b9fbb87ce.svg";
export { ForwardRef as ReactComponent };